import React, { useEffect, useState } from "react";
import classes from "./VerifedEmailPage.module.css";
import { Row, Col, Container } from "react-bootstrap";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import {
  ArrowUpRightBlue,
  BackwardArrow,
  CancelredIcon,
  CheckGreen,
  logo,
  studentSignupCover,
} from "../../constant/imagePath";
import { useHistory, useLocation } from "react-router";
import Fonts from "../../stories/assets/Fonts";
import Colors from "../../stories/assets/Colors";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { apiHeader, BaseURL } from "../../Config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { Button } from "../../stories/Button/Button";
import { applyActionCode, getAuth } from "firebase/auth";
import { toast } from "react-toastify";

export default function VerifedEmailPage() {
  const history = useHistory();
  const queryParams = new URLSearchParams(window.location.search);
  const actionCode = queryParams.get("oobCode");
  const [isMobile, setIsMobile] = useState(false);
  const [verificationFailed, setVerificationFailed] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  const HandleFirebaseEmailVerification = async () => {
    const auth = getAuth();
    applyActionCode(auth, actionCode).then((resp) => {
      console.log(resp);
    setVerificationFailed(false);
    }).catch((error) => {
      setVerificationFailed(true);
    });
  }
  return (
    <>
      <style jsx>{`
        .${classes.mainHeading} {
          font-size: ${isMobile ? "26px" : Fonts.h3.fontSize};
          line-height: ${isMobile ? "32px" : Fonts.h3.lineHeight};
          font-family: ${isMobile ? Fonts.h2.fontFamily : Fonts.h3.fontFamily};
          color: ${Colors.neutralShadesOfNero};
        }
      `}</style>
      <div>
        <Container fluid className={classes.container}>
          <Row>
            {isMobile ? (
              <MobileHeader
                isLogo={true}
                isAvatar={false}
                customStyle={{ padding: "16px 0px 0px 16px " }}
              />
            ) : (
              <BeforeLoginHeader
                onClick={() => {
                  history.push({
                    pathname: "login",
                  });
                }}
                icon={logo}
                text1={"Already have an account?"}
                text2={"Log in"}
              />
            )}

            <Col
              md={6}
              className={`p-0  ${[
                classes.imageContainer,
                classes.innerContainer,
              ].join(" ")}`}
            >
              <img
                className="img-fluid d-block w-100 hvh-100"
                src={studentSignupCover}
              />
            </Col>
            <Col
              md={6}
              className={`
              // p-5
                ${[classes.innerContainer, classes.rightContainer].join(" ")}`}
            >

              <div className={classes.mainContent}>
                <div className={classes.centerContainer}>
                  <img src={verificationFailed? CancelredIcon : CheckGreen} />
                </div>
                <h3 className={classes.mainHeading}>Verification {verificationFailed ? 'Failed' : 'Success'}</h3>
                {verificationFailed ?<p style={{ ...Fonts.p1, color: Colors.suvaGrey }}>
                  We are faceing some issue while verifying your email. Please try again later.
                  </p>
                               :
                <p style={{ ...Fonts.p1, color: Colors.suvaGrey }}>
                  Thank You for your support, we have Successfully verified yur account, Now you can login to access lytesnap Features.
                </p>}
                <div className={classes.centerContainer}>
                  <Button
                    primary={true}
                    disabled={false}
                    size={"Medium"}
                    label={verificationFailed ? "Try Again" : "Continue"}
                    onClick={() => {
                      verificationFailed ? HandleFirebaseEmailVerification() : 
                      history.push({
                        pathname: "login",
                      });
                    }}
                    customStyle={{
                      width: "auto",
                    }}
                  />
                </div>
              </div>
              {/* Already have account Login for mobile  */}
              <div className={classes.alreadyHaveAccountForMobile}>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Already have an account?
                </p>
                <LinkButtonWithIcon
                  primary={true}
                  text={"Log in"}
                  rightIcon={ArrowUpRightBlue}
                  iconStyle={{ margin: "0px" }}
                  onClick={() => history.push("/login")}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
